import {
  ExternalRoute as ExternalRouteDefinitions,
  type ExternalRoute,
} from "@/constants/externalRoute.ts"
import { type EnrolmentRoute } from "@/constants/routes/enrolment.ts"
import { type MyAccountRoute } from "@/constants/routes/myAccount.ts"
import router from "@/plugins/router/index.ts"
import { RouteRecord, RouteRecordRaw } from "vue-router"

export const isInternalRoute = (
  routeName: string | undefined,
  routes: RouteRecord[] | readonly RouteRecordRaw[],
): routeName is MyAccountRoute | EnrolmentRoute => {
  if (!routeName) return false
  if (["mailto:", "tel:", "#"].some((prefix) => routeName.startsWith(prefix))) {
    return false
  }

  const resolution = router(routes).resolve(routeName)

  return (
    (resolution?.matched?.length ?? 0) > 0 && resolution?.name !== "notFound"
  )
}

export function isExternalRoute(route?: string): route is ExternalRoute {
  if (!route) return false

  // make sure query params don't interfere with route matching
  const url = route.split(/[?#]/)[0]

  return Object.values(ExternalRouteDefinitions).includes(url)
}
